import React from "react";
import { useHistory, useParams } from "react-router-dom";
import config from "../../config/config";
import { Checkbox } from "@mui/material";
import moment from "moment";
// import MenuIcon from "@material-ui/icons/Menu";
import MenuIcon from '@mui/icons-material/Menu';
// import "../Dashboard/vehicleList.css";
import redIcon from "../../img/mid1.png";
// import ReplayIcon from "@mui/material/icons/Replay";
import ReplayIcon from '@mui/icons-material/Replay';

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Polyline,
  InfoWindow,
  Circle,
  Polygon,
  DirectionsRenderer,
  Rectangle,
  OverlayView,
} from "react-google-maps";
import stopIcon from "../../img/stop.png";
import markerIcon from "../../img/green_truck.svg";
import markerIconYellow from "../../img/green_yellow_car.svg";

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
// import makeStyles  from '@mui/styles';
import { AddressAction } from "../../actions/Address";
import ClearIcon from '@mui/icons-material/Clear';
// import { AddressAction } from "../../actions/Address";
import { SiteAction } from "../../actions/site";
import UserWithLabel from "./userWithLabel"
// const {
//   MarkerWithLabel,
// } = require("react-google-maps/lib/components/addons/MarkerWithLabel");
const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");

class Map extends React.Component {
  constructor(props) {
    super(props);

  }

  state = {
    progress: [],
    progressStop: [],
    defaultCenter: { lat: "", lng: "" },
    markerAnimation: { lat: "", lng: "" },
    centerCor: { lat: "", lng: "" },
    isOpen: false,
    toggle: true,
    vehicleNumber: "",
    address: "",
    googleApi: false,
    showSites: true,
    showLabel: false,
    vehicleCenter: true,
    siteRouteList: [],
    RouteListPoly: [],
    showrouteCheck: true,
    showStops: true,
    loadingUnloading: false,
    vehicleSppeds: 1,
    vehicleRunningTrip: false,
    userInfo: {},
    pathLIneTrip: []
  };

  /*=================== info window popup================== */
  handleToggleOpen = (value) => {
    console.log(value,"dfghj")
    this.setState({
      isOpen: true,
    });

    // if (value.lat) {
    //   this.fetchAddress(value.lat, value.lng);
    // } else {
    //   this.fetchAddress(value.lat(), value.lng());
    // }
  };

  handleToggleClose = () => {
    this.setState({
      isOpen: false,
    });
  };
  /* ============================================ */

  /* set toggle state to open or close on remove icon */
  setToggle = (value) => {
    this.setState({
      toggle: value,
    });
  };

  fetchAddress = (lat, lng) => {
    //console.log(lat,lng)
    AddressAction.AddressList({
      appKey: JSON.parse(localStorage.getItem("data")).addressAppKey,
      coordinatesDTOList: [
        {
          latitude: lat,
          longitude: lng,
        },
      ],
    }).then((res) => {
      //console.log(res)

      if (res != null) {
        if (res.responseCode == 500 || res.responseCode == 204) {
          this.setState({ address: res.responseDescription });
        } else {
          let valueAddress = res.data[0].address;

          this.setState({ address: valueAddress });
        }
      } else {
        //console.log(JSON.parse(res))
      }
    });
  };

  path = [];
  anglePath = []
  stopPath = [];
  polylineTrip = [];
  pathLastPosition = [];
  infoWindowArray = [];
  gpsRefId = 67;
  velocity = 100;
  initialDate = new Date();
  counter = 0;
  counterStop = 0;
  coordinates = [];
  arraylatLng = [];

  lastfetchedTime = new Date().toISOString();
  stopFromtime = new Date().toISOString();

  // fetchById = () => {
  //   VehicleAction.etpOrderFetch({
  //     orderId: 1,
  //     companyId: JSON.parse(localStorage.getItem("data")).companyId,
  //   }).then((response) => {
  //     if (response != null) {
  //       response.data.route.geofenceDTOList.map((item) => {
  //         this.pathLIneTrip.push({ lat: item.latitude, lng: item.longitude });
  //       });
  //     } else {
  //     }
  //   });
  // };

  // fetchSiteList = async () => {
  //   SiteAction.fetchSiteRouteSubSite({
  //     companyId: JSON.parse(localStorage.getItem("data")).companyId,
  //     showSubSite: false,
  //     showRoute: true,
  //   }).then((response) => {
  //     //debugger
  //     if (response != null) {
  //       console.log(response);
  //       this.setState({
  //         siteRouteList: response,
  //       });
  //       this.routeArrayList(response.routeDTOList);
  //       //  let sitess= response.siteDTOList.filter((e) => e.parentSiteId == null)
  //       //   console.log(sitess)
  //       // setSiteList(sitess)
  //       // setSiteListOld(sitess)
  //       // routeArrayList(response.routeDTOList)
  //       // setRouteListOld(response.routeDTOList)
  //     } else {
  //       // setSiteList([])
  //       // setSiteListOld([])
  //     }
  //   });
  // };

  // routeArrayList = (routeArrays) => {
  //   let routeArray = [];
  //   routeArrays.forEach((element) => {
  //     const v1 = element.geofenceDTOList.map(
  //       ({ latitude: lat, longitude: lng, ...rest }) => ({
  //         lat,
  //         lng,
  //         ...rest,
  //       })
  //     );
  //     let routeObj = {
  //       bgColor: element.geofenceColor,
  //       DToList: v1,
  //       source: element.source,
  //       destination: element.destination,
  //     };
  //     routeArray.push(routeObj);
  //   });
  //   this.setState({
  //     RouteListPoly: routeArray,
  //   });
  //   // setShowRouteList(routeArray)
  // };

  fetchByIdVehicle = async (type) => {
    if (window.location.pathname.split("/")[2] == 0) {
      return false;
    }
    debugger
    AddressAction.getPositionsOfUser({
      id: window.location.pathname.split("/")[2],
      // companyId: JSON.parse(localStorage.getItem("data")).companyId,
    }).then((response) => {
      if (response != null) {
        this.setState({ progress: response.data })
        setTimeout(() => {
          this.fetchByIdVehicle(true);
        }, 30000);

        if (type) {
          this.setState({
            // vehicleRunningTrip: response.isRunning,
          });
        } else {
          // this.setState({
          //   vehicleRunningTrip: response.isRunning,
          // });

          // this.gpsRefId=78
          // this.gpsRefId = response.gpsRefId;
          // this.setState({
          //   vehicleNumber: response.number,
          // });
          if (response) {
            if (this.props.history !== "true") {
              this.getLastLatLong();

              this.getInitialPositions();
            } else {
              this.getLastLatLong();
            }
          }
        }
      } else {
        // alert('Something went wrong')
      }
    });
  };

  getLastLatLong = async () => {
    // const responseForLaatLocation = await fetch(
    //   `${
    //     JSON.parse(localStorage.getItem("config")).coreUrl
    //   }api/positions/?deviceId=${this.gpsRefId}`,
    //   {
    //     headers: {
    //       Accept: "application/json",
    //       Authorization:
    //         "Basic " + btoa(`${JSON.parse(localStorage.getItem("config")).coreUsername}:${JSON.parse(localStorage.getItem("config")).corePassword}`),
    //     },
    //   }
    // );

    const userId = window.location.pathname.split("/")[2]
    const lastLocation = await AddressAction.getPositionsOfUser({ id: userId })
    //console.log(lastLocation[0])
    if (lastLocation && lastLocation.length > 0 && lastLocation[0] !== null) {
      this.infoWindowArray = lastLocation;
      this.path.push({
        lat: lastLocation.length > 0 ? lastLocation[0].latitude : "",
        lng: lastLocation.length > 0 ? lastLocation[0].longitude : "",
        speed: 0,
        ignition: lastLocation[0].attributes.ignition,
        serverTime: lastLocation[0].serverTime,
      });

      let progress = this.path;
      this.setState({ progress });
      let { centerCor } = this.state; //Gets the object from state
      centerCor.lat =
        lastLocation.length > 0 ? lastLocation[0].latitude : 23.73111117910784; //do whatever you want with the object
      centerCor.lng =
        lastLocation.length > 0 ? lastLocation[0].longitude : 87.05557365974347; //do whatever you want with the object
      this.setState({ centerCor });
    } else {
      alert("No location Available");
    }
  };

  getInitialPositions = async () => {
    debugger
    /* convert from date and to date coming from props */
    let from, to;
    if (this.props.history === "true") {
      from = this.props.fromDate;
      let milliseconds = Date.parse(from);
      milliseconds = milliseconds;
      from = new Date(milliseconds).toISOString();
      let millisecondsTo = Date.parse(this.props.toDate);
      millisecondsTo = millisecondsTo;
      to = new Date(millisecondsTo).toISOString();

      /*============================================================*/
      this.path = [];
      this.stopPath = [];
    } else {
      from = new Date();
      let milliseconds = Date.parse(from);
      milliseconds = milliseconds - 5 * 60 * 1000;
      from = new Date(milliseconds).toISOString();
      to = new Date().toISOString();
      this.lastfetchedTime = to;
    }
    // 192.168.200.16:

    window.clearInterval(this.interval);
    this.initialDate = new Date();
    ////console.log(to);
    // rapidfleet.nyggs.com:
    // const response = await fetch(
    //   `${
    //     JSON.parse(localStorage.getItem("config")).coreUrl
    //   }api/positions/?deviceId=${this.gpsRefId}&from=${from}&to=${to}`,
    //   {
    //     headers: {
    //       Accept: "application/json",
    //       Authorization:
    //         "Basic " + btoa(`${JSON.parse(localStorage.getItem("config")).coreUsername}:${JSON.parse(localStorage.getItem("config")).corePassword}`),
    //     },
    //   }
    // );
    const userId = window.location.pathname.split("/")[2];

    const res = await AddressAction.getPositionsOfUser({ id: userId })

    // this.setState({
    //   userInfo: {
    //     url: res.image_url + "#custom_marker",
    //     origin: new window.google.maps.Point(0, 0),
    //     anchor: new window.google.maps.Point(15, 15),
    //     scaledSize: new window.google.maps.Size(30, 30),
    //     shape: { coords: [17, 17, 18], type: "circle" },
    //     optimized: false,
    //     title: "spot",
    //   }

    //   // shape: { coords: [50, 50, 18], type: "circle" },
    // })
    const items = res.data
    // const response = await fetch(`
    //   `http://rapidfleet.nyggs.com:8082/api/positions?deviceId=31&from=2021-07-22T13:29:00Z&to=2021-07-28T13:29:00Z`,
    //   {
    //     headers: {
    //       Accept: "application/json",
    //     'Authorization': 'Basic '+btoa('admin:R@pids0ft')

    //     },
    //   }
    // );

    // let items = await response.json();
    console.log(items);

    // items=flightPlanCoordinates
    if (items.length > 0) {
      items.sort(function (a, b) {
        return a.deviceTime - b.deviceTime;
      });
      /* =========================  positions lat and long array============================== */
      this.infoWindowArray = items;
      this.path = [];
      let progress = [];
      this.counter = 0;
      this.setState({ progress });
      this.setState({ showLabel: false });
    } else {
      this.setState({ showLabel: true });
      if (this.props.history === "true") {
        this.setState({ showLabel: false });
        this.getLastLatLong();
      }
    }

    if (this.props.history != "true") {
      items.map((item) => {
        this.path.push({
          lat: parseInt(item.latitude),
          lng: parseInt(item.longitude),
          speed: item.speed ? item.speed : null,
          ignition: true,
          serverTime: item.deviceTime ? moment(item.deviceTime).format("DD-MM-YYYY HH:mm") : null,
        });
        return this.path;
      });
    } else {
      // var finalSpeed = this.getspeed(items);
      // console.log(finalSpeed);
      // this.path = finalSpeed;
    }
    /* =======================Path is a position Array with lat lng server time */
    // items.map((item) => {
    //   console.log(item.speed)

    //   this.path.push({ lat: item.latitude, lng: item.longitude,speed:item.speed,ignition:true,serverTime:item.deviceTime });
    //   return this.path;
    // });

    if (this.state.googleApi) {
      // this.getlatLng()
    } else {
      //console.log('***************************************')
      // this.getCordinates()
      // this.interval = window.setInterval(this.moveObject, 1000);
    }
    // let count=1

    // setInterval(() => {
    //     this.animatedMove('marker', .5, this.path[count-1], this.path[count],count );
    //     count =count+1
    //   }, 5000 );

    this.getCordinates();
    this.interval = window.setInterval(this.moveObject, 1000);
    // this.getCordinates()
    console.log(this.path.length);

    this.getStopLatLng(this.path);
    if (this.props.history == "true") {
      var resultPath = this.path.reduce((unique, o) => {
        if (!unique.some((obj) => obj.lat === o.lat && obj.lng === o.lng)) {
          unique.push(o);
        }
        return unique;
      }, []);

      console.log(resultPath);
      this.path = resultPath;
      console.log(this.path.length);
      if (this.path.length > 0) {
        let progress = this.state.progress; //Extract last all positions which we have already rendered.
        const position = this.path[0]; //Pick next position from path which we have to render.
        progress = progress.concat(position);
        this.setState({ progress });
        const { centerCor } = this.state; //Gets the object from state
        centerCor.lat = this.path[0].lat; //do whatever you want with the object
        centerCor.lng = this.path[0].lng; //do whatever you want with the object
        this.setState({ centerCor });
      }
    }
    if (this.props.history !== "true") {
      setTimeout(() => {
        this.getPositions30Seconds();
      }, 30000);
    }
  };

  getspeed = (arr) => {
    console.log(arr.length);

    const result1 = arr.reduce((acc, value) => {
      // compare the current value with the last item in the collected array
      if (acc.length && acc[acc.length - 1][0].speed == value.speed) {
        // append the current value to it if it is matching
        acc[acc.length - 1].push(value);
      } else {
        // append the new value at the end of the collected array
        acc.push([value]);
      }

      return acc;
    }, []);

    console.log(result1);

    let speedArray = [];
    result1.map((value) => {
      console.log(value);
      value.forEach((item) => {
        let speedObj = {
          lat: value[0].latitude,
          lng: value[0].longitude,
          speed: item.speed,
          ignition: true,
          serverTime: item.deviceTime,
        };
        speedArray.push(speedObj);
      });
    });
    console.log({ speedArray });
    return speedArray;
  };


  getPositions30Seconds = async () => {
    debugger
    //this.counter = 0;

    //this.path = [];
    //this.counter = 0;
    let p1 = []
    let from = new Date();
    let milliseconds = Date.parse(from);
    milliseconds = milliseconds - 0.5 * 60 * 1000;
    from = new Date(milliseconds).toISOString();

    from = this.lastfetchedTime;

    ////console.log(from);
    const to = new Date().toISOString();
    const userId = window.location.pathname.split("/")[2];



    const res = await AddressAction.getPositionsOfUser({ id: userId })

    this.setState((pre => {
      return {
        ...pre, userInfo: {
          startPoint: res.data.userInstantLocationHistory && res.data.userInstantLocationHistory.length > 1 && res.data.userInstantLocationHistory[0],
          endPoint: res.data.userInstantLocationHistory && res.data.userInstantLocationHistory.length > 1 && res.data.userInstantLocationHistory[res.data.userInstantLocationHistory.length - 1],
          distance: res.data.distance && res.data.distance,
          empCode: res.data.empCode && res.data.empCode,
          imgUrl: res.data.imgUrl && res.data.imgUrl,
          userName: res.data.userName && res.data.userName
        }
      }
    }))

    let items = res && res.data && res.data.userInstantLocationHistory && res.data.userInstantLocationHistory != null && res.data.userInstantLocationHistory.length > 1 && res.data.userInstantLocationHistory;
    const center = { lat: items && items.length > 0 && items[items.length - 1].latitude, lng: items && items.length > 0 && items[items.length - 1].longitude }
    this.setState({ centerCor: center })
    console.log(this.state.userInfo)
    console.log(items);

    // items=flightPlanCoordinates1
    if (items && items.length > 0) {
      this.lastfetchedTime = to;
      items.sort(function (a, b) {
        return new Date(a.deviceTime) - new Date(b.deviceTime);
      });
    }
    items && items.length > 0 && items.map((item) => {
      p1.push({ lat: item.latitude, lng: item.longitude });
    })

    this.setState({ pathLIneTrip: p1 })

    items && items.length > 0 && items.map((item, index, array) => {
      debugger


      this.infoWindowArray.push(item);

      // const { latitude: lat1, longitude: lng1 } = item;
      // const latLong1 = new window.google.maps.LatLng(lat1, lng1);

      // // console.log(array[index + 1]);
      // const { latitude: lat2, longitude: lng2 } = array[index == array.length - 1 ? index : index + 1];
      // const latLong2 = new window.google.maps.LatLng(lat2, lng2);

      // const angle = window.google.maps.geometry.spherical.computeHeading(
      //   latLong1,
      //   latLong2
      // );
      // console.log(angle)

      this.path.push({
        lat: item.latitude,
        lng: item.longitude,
        speed: item.speed ? item.speed : null,
        ignition: true,
        serverTime: item.deviceTime ? moment(item.deviceTime).format("DD-MM-YYYY HH:mm") : null,
        // imageAngel: <img src={require("../../img/fuel11.png")} style={{
        //   width: "10px",
        //   transform: `rotate(${angle}deg)`,
        // }} alt="" />
      });

      // console.log(this.path)
      return this.path;
    });

    // let speedArrayNew = [];
    // [...this.path].map((ele, index, array) => {
    //   let objWithAngle = {};

    //   const { lat: lat1, lng: lng1 } = ele;
    //   const latLong1 = new window.google.maps.LatLng(lat1, lng1);

    //   // console.log(array[index + 1]);
    //   const { lat: lat2, lng: lng2 } = array[index == array.length - 1 ? index : index + 1];
    //   const latLong2 = new window.google.maps.LatLng(lat2, lng2);

    //   const angle = window.google.maps.geometry.spherical.computeHeading(
    //     latLong1,
    //     latLong2
    //   );


    //   // let img = document.createElement("img");
    //   // img.src = require("../../img/fuel11.png");

    //   // img.style.border = "10px solid orange";
    //   // img.style.borderRadius = "10px";

    //   // document.body.appendChild(img);
    //   //       const img = new Image(100, 200); // width, height
    //   // img.src = "https://picsum.photos/200/301";
    //   // document.body.appendChild(img);

    //   const imageAngel =
    //     (<img
    //       style={{
    //         transform: `rotate(${angle}deg)`,
    //         width: "25px",
    //       }}
    //       src={require("../../img/fuel11.png")}
    //       alt=""
    //     />
    //     );


    //   // objWithAngle = { ...ele, imageAngel };
    //   // this.anglePath.push(objWithAngle);
    // });



    // console.log(this.anglePath, "dfghjk")
    ////console.log(this.path);
    // this.getCordinates()
    if (this.state.googleApi) {
      // this.getlatLng()
    } else {
      this.getCordinates();
      // console.log(this.getCordinates());
    }

    console.log(this.path);
    // this.getCordinates()
    this.getStopLatLng(this.path);

    setTimeout(() => {
      this.getPositions30Seconds();
    }, 5000);
    // let progress = this.path;
    // this.setState({ progress });
  };

  getlatLng = () => {
    for (let i = 0; i < this.path.length - 1; i++) {
      const latLong1 = new window.google.maps.LatLng(
        this.path[i].lat,
        this.path[i].lng
      );
      const latLong2 = new window.google.maps.LatLng(
        this.path[i + 1].lat,
        this.path[i + 1].lng
      );
      const distance =
        window.google.maps.geometry.spherical.computeDistanceBetween(
          latLong1,
          latLong2
        );
      //console.log(distance)

      if (distance > 200) {
        let sss = this.getRoutebetweenTwoLatLng(
          this.path[i],
          this.path[i + 1],
          i,
          i + 1
        );
      }
    }
  };

  getRoutebetweenTwoLatLng = (origin1, destination1, index, nextIndex) => {
    debugger
    const directionsService = new window.google.maps.DirectionsService();
    // const waypoints = props.midPoints.map((item) => {
    //   if (item.name && item.name !== null) {
    //     return {
    //       location: { lat: item.latitude, lng: item.longitude },
    //       stopover: true,
    //     };
    //   }
    // });

    const origin = {
      lat: origin1.lat,
      lng: origin1.lng,
    };
    const destination = {
      lat: destination1.lat,
      lng: destination1.lng,
    };

    directionsService.route(
      {
        origin: origin,
        destination: destination,

        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        console.log(result)
        if (status === window.google.maps.DirectionsStatus.OK) {
          let pathCal = this.calculateTotalPath(result);
          this.addArraybetweenTwo(pathCal, index, nextIndex);
        } else {
          //console.error(`error fetching directions ${result}`);
        }
      }
    );
  };

  addArraybetweenTwo = (arraynew, index, nextindex) => {
    // this.arraylatLng=[]
    for (var i = 0; i < this.path.length - 1; i++) {
      if (index > i) {
        this.valuePushLatLng(this.path[i], "small");

        // arrayIndex.push({ lat: this.path[i].lat, lng: this.path[i].lng ,index:i});
      }
    }

    arraynew.forEach((element) => {
      this.valuePushLatLng(element, "long");
      // arrayIndex.push({ lat: element.latitude, lng: element.longitude });
    });

    for (var i = nextindex; i < this.path.length - 1; i++) {
      this.valuePushLatLng(this.path[i], "small");
      // arrayIndex.push({ lat: this.path[i].lat, lng: this.path[i].lng,index:i });
    }
    // let xaaa=this.sortByKey(this.arraylatLng,'lat')
    // //console.log(xaaa)
    this.path = this.arraylatLng;

    this.getCordinates();
    let xaaa = this.sortByKey(this.path, "distance");
    this.path = xaaa;
    this.interval = window.setInterval(this.moveObject, 1000);
  };

  sortByKey(array, key) {
    return array.sort(function (a, b) {
      return a[key] - b[key];
    });
  }

  calculateTotalPath(result) {
    // alert("ihi")
    this.coordinates = [];
    var route = result.routes[0];
    for (var i = 0; i < route.legs.length; i++) {
      let o = { latitude: "", longitude: "" };
      let x = { latitude: "", longitude: "" };
      o.latitude = route.legs[i].start_location.lat();
      o.longitude = route.legs[i].start_location.lng();

      this.valuePush(o);

      route.legs[i].steps.forEach((element) => {
        let o = { latitude: "", longitude: "" };

        o.latitude = element.start_location.lat();
        o.longitude = element.start_location.lng();
        this.valuePush(o);

        var count = 0;
        element.path.forEach((element) => {
          count = count + 1;
          let o = { latitude: "", longitude: "" };
          o.latitude = element.lat();
          o.longitude = element.lng();
          this.valuePush(o);
        });
        let x = { latitude: "", longitude: "" };
        x.latitude = element.end_location.lat();
        x.longitude = element.end_location.lng();
        this.valuePush(x);
      });
      x.latitude = route.legs[i].end_location.lat();
      x.longitude = route.legs[i].end_location.lng();
      this.valuePush(x);
    }
    return this.coordinates;
  }

  animatedMove(marker, t, current, moveto, index) {
    //console.log(index)
    var lat = current.lat;
    var lng = current.lng;

    var deltalat = (moveto.lat - current.lat) / 100;
    var deltalng = (moveto.lng - current.lng) / 100;
    // const { markerAnimation } = this.state; //Gets the object from
    var delay = 100 * t;
    for (var i = 0; i < 100; i++) {
      (function (ind) {
        setTimeout(function () {
          var lat = current.lat;
          var lng = current.lng;
          lat += deltalat;
          lng += deltalng;
          let latlng = new window.google.maps.LatLng(lat, lng);
          //console.log(latlng)
          // const { markerAnimation } = this.state; //Gets the object from
          // //console.log(markerAnimation)

          // markerAnimation.lat = latlng.lat() //do whatever you want with the object
          // markerAnimation.lng = latlng.lng() //do whatever you want with the object

          // //console.log(markerAnimation)
          this.setState({
            markerAnimation: { lat: latlng.lat(), lng: latlng.lng() },
          });
          //  let progress = progress.concat(latlng);
          // this.setState({ progress });
          // marker.setPosition(latlng);
        }, delay * ind);
      })(i);
    }
  }

  valuePushLatLng = (val, type) => {
    var found = 0;

    this.arraylatLng.forEach((element) => {
      if (type == "small") {
        if (element.lat === val.lat && element.lng === val.lng) {
          found = 1;
        }
      } else {
        if (element.lat === val.latitude && element.lng === val.longitude) {
          found = 1;
        }
      }
    });
    if (found === 0) {
      if (type == "small") {
        this.arraylatLng.push({
          lat: val.lat,
          lng: val.lng,
          speed: 0,
          ignition: true,
        });
      } else {
        this.arraylatLng.push({
          lat: val.latitude,
          lng: val.longitude,
          speed: 0,
          ignition: true,
        });
      }
    }
  };

  valuePush = (val) => {
    var found = 0;

    this.coordinates.forEach((element) => {
      if (
        element.latitude === val.latitude &&
        element.longitude === val.longitude
      ) {
        found = 1;
      }
    });
    if (found === 0) {
      this.coordinates.push(val);
    }
  };

  getStopPositions30Seconds = async () => {
    //this.counter = 0;
    //this.path = [];
    //this.counter = 0;
    // let from = new Date();
    // let milliseconds = Date.parse(from);
    // milliseconds = milliseconds - 0.5 * 60 * 1000;
    // from = new Date(milliseconds).toISOString();
    // from = this.stopFromtime;
    // ////console.log(from);
    // const to = new Date().toISOString();
    // from = "2021-05-02T18:30:00.000Z";
    // // this.lastfetchedTime = to;
    // ////console.log(to);
    // // to="2021-05-03T18:29:59.999Z"
    // const response = await fetch(
    //   `/api/reports/stops/?deviceId=${
    //     window.location.pathname.split("/")[3]
    //   }&from=${from}&to=2021-05-03T18:29:59.999Z`,
    //   {
    //     headers: {
    //       Accept: "application/json",
    //     },
    //   }
    // );
    // const items = await response.json();
    // ////console.log("***************************************");
    // ////console.log(items);
    // this.stopPath = [];
    // this.state.progressStop = [];
    // this.counterStop = 0;
    // items.map((item) => {
    //   this.stopPath.push({
    //     lat: item.latitude,
    //     lng: item.longitude,
    //     distance: 0,
    //     status: "stop",
    //   });
    // let progress = this.path;
    //   // this.setState({ progress });
    //   return this.stopPath;
    // });
    // ////console.log(this.stopPath);
    // let progressStop = this.stopPath;
    // this.setState({ progressStop });
    //  this.getStopLatLng(this.stopPath)
  };

  getStopLatLng = (arr) => {
    console.log(arr.length);

    const result = arr.reduce((acc, value) => {
      // compare the current value with the last item in the collected array
      if (
        acc.length &&
        acc[acc.length - 1][0].lat == value.lat &&
        acc.length &&
        acc[acc.length - 1][0].lng == value.lng
      ) {
        // append the current value to it if it is matching
        acc[acc.length - 1].push(value);
      } else {
        // append the new value at the end of the collected array
        acc.push([value]);
      }

      return acc;
    }, []);

    const result1 = arr.reduce((acc, value) => {
      // compare the current value with the last item in the collected array
      if (acc.length && acc[acc.length - 1][0].speed == value.speed) {
        // append the current value to it if it is matching
        acc[acc.length - 1].push(value);
      } else {
        // append the new value at the end of the collected array
        acc.push([value]);
      }

      return acc;
    }, []);

    console.log(result1);

    var results = result1.filter((vl) => {
      if (vl.length >= 2) {
        return vl;
      }
    });
    console.log(results);

    let stopArr = [];
    results.map((value) => {
      let stopObj = {
        lat: "",
        lng: "",
        startTime: "",
        endTime: "",
      };

      var dt1 = new Date(value[0].serverTime);
      var dt2 = new Date(value[value.length - 1].serverTime);

      var diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60;
      ////console.log(diff)
      var diffs = Math.abs(Math.round(diff));
      ////console.log(diffs)
      if (diff >= 5) {
        stopObj.lat = parseFloat(value[0].lat);
        stopObj.lng = parseFloat(value[0].lng);
        stopObj.startTime = value[0].serverTime;
        stopObj.endTime = value[value.length - 1].serverTime;
        ////console.log(value[0])
        ////console.log(value[value.length-1])
        stopArr.push(stopObj);
      }
    });
    ////console.log(stopArr);
    let progressStop = stopArr;
    this.setState({ progressStop });
    console.log(this.state.progressStop);
  };

  getDistance = () => {
    // seconds between when the component loaded and now
    const differentInTime = (new Date() - this.initialDate) / 1000; // pass to seconds
    return differentInTime * this.velocity;
  };

  componentDidMount = () => {
    if (window.location.pathname.split("/")[2] != 0) {

      /* this method is called during the initial render of the page */
      this.getPositions30Seconds();
    }

    // this.interval = window.setInterval(this.moveObject, 1000);
    // this.interval = window.setInterval(this.moveObjectStop, 100);
  };

  componentWillUnmount = () => {
    //console.log(this.props.history)
    //window.clearInterval(this.interval);
    window.clearInterval(this.positionUpdate);
  };

  position = [];
  numDeltas = 100;
  delay = 100; //milliseconds
  i = 0;
  deltaLat;
  deltaLng;

  moveMarker = (time) => {
    this.position[0] += this.deltaLat;
    this.position[1] += this.deltaLng;
    var latlng = new window.google.maps.LatLng(
      this.position[0],
      this.position[1]
    );
    // marker.setTitle("Latitude:"+this.position[0]+" | Longitude:"+this.position[1]);
    // marker.setPosition(latlng);
    // map.setCenter(latlng)
    let progress = this.state.progress; //Extract last all positions which we have already rendered.
    const position = latlng; //Pick next position from path which we have to render.
    progress = progress.concat(position);

    this.setState({ progress });
    if (this.i != this.numDeltas) {
      this.i++;
      setTimeout(this.moveMarker, 10);
    }
  };

  transition = (current, moveto, time) => {
    this.i = 0;
    this.deltaLat = (moveto.lat - this.position[0]) / this.numDeltas;
    this.deltaLng = (moveto.lng - this.position[1]) / this.numDeltas;
    this.moveMarker(time);
  };

  moveObject = () => {

    // Check if there are more objects to render or not
    if (this.counter <= this.path.length - 1) {
      this.counter = this.counter;
    } else {
      return;
    }

    // this.position.push(this.path[this.counter-1].lat)
    // this.position.push(this.path[this.counter-1].lng)
    // this.transition(this.path[this.counter-1],this.path[this.counter],100)

    let progress = this.state.progress; //Extract last all positions which we have already rendered.
    const position = this.path[this.counter]; //Pick next position from path which we have to render.
    progress = progress.concat(position);

    this.setState({ progress });

    const { centerCor } = this.state; //Gets the object from state
    centerCor.lat = progress[progress.length - 1].lat; //do whatever you want with the object
    centerCor.lng = progress[progress.length - 1].lng; //do whatever you want with the object
    this.setState({ centerCor });
    return false;
    const distance = this.getDistance();
    // if (!distance) {
    //   return;
    // }
    //console.log(distance)
    //console.log(this.path)

    // let progress = this.path.filter(
    //   coordinates => coordinates.distance
    // );
    // //console.log(progress)
    // let { centerCor } = this.state; //Gets the object from state

    // if(progress.length==0){
    //   if(this.path.length > 0){
    //     centerCor.lat = this.path[this.path.length - 1].lat; //do whatever you want with the object
    //     centerCor.lng = this.path[this.path.length - 1].lng;
    //     progress = progress.concat(centerCor);
    //     this.setState({ progress });
    //   }

    // }
    // const nextLine = this.path.find(

    //   coordinates => coordinates.distance
    // );
    // if (!nextLine) {
    //   this.setState({ progress });
    //   return; // it's the end!
    // }

    // //console.log(this.state.progress)
    // const lastLine = progress[progress.length - 1];

    // const lastLineLatLng = new window.google.maps.LatLng(
    //   lastLine.lat,
    //   lastLine.lng
    // );

    // const nextLineLatLng = new window.google.maps.LatLng(
    //   nextLine.lat,
    //   nextLine.lng
    // );

    // // distance of this line
    // const totalDistance = nextLine.distance - lastLine.distance;
    // const percentage = (distance - lastLine.distance) / totalDistance;

    // const position = window.google.maps.geometry.spherical.interpolate(
    //   lastLineLatLng,
    //   nextLineLatLng,
    //   percentage
    // );

    // const { centerCor } = this.state; //Gets the object from state
    // centerCor.lat = progress[progress.length - 1].lat; //do whatever you want with the object
    // centerCor.lng = progress[progress.length - 1].lng; //do whatever you want with the object
    // this.setState({ centerCor });
    // progress = progress.concat(nextLineLatLng);
    // this.setState({ progress });
  };

  moveObjectStop = () => {
    // Check if there are more objects to render or not
    ////console.log(this.counterStop);
    ////console.log(this.state.progressStop);
    // this.state.progressStop=[]
    if (this.counterStop < this.stopPath.length - 1) {
      this.counterStop = this.counterStop + 1;
    } else {
      return;
    }

    let progressStop = this.state.progressStop; //Extract last all positions which we have already rendered.
    const position = this.path[this.counterStop]; //Pick next position from path which we have to render.
    progressStop = progressStop.concat(position);

    this.setState({ progressStop });

  };

  getCordinates = () => {
    debugger
    this.path = this.path.map((coordinates, i, array) => {
      if (i === 0) {
        return { ...coordinates, distance: 0 }; // it begins here!
      }

      const { lat: lat1, lng: lng1 } = coordinates;
      const latLong1 = new window.google.maps.LatLng(lat1, lng1);

      const { lat: lat2, lng: lng2 } = array[0];
      const latLong2 = new window.google.maps.LatLng(lat2, lng2);

      // in meters:
      const distance =
        window.google.maps.geometry.spherical.computeDistanceBetween(
          latLong1,
          latLong2
        );

      return { ...coordinates, distance };
    });
  };

  componentDidUpdate = (prevProps) => {
    console.log(this.state.vehicleCenter ,"dfghj")

    if (this.state.vehicleCenter == true && this.state.pathLIneTrip.length > 0) {
    //   // console.log(this.state.pathLIneTrip,"dfghjk")
      this.mapRef.panTo(
        new window.google.maps.LatLng(
          this.state.pathLIneTrip[this.state.pathLIneTrip.length - 1] &&
          this.state.pathLIneTrip[this.state.pathLIneTrip.length - 1].lat,
          this.state.pathLIneTrip[this.state.pathLIneTrip.length - 1] &&
          this.state.pathLIneTrip[this.state.pathLIneTrip.length - 1].lng
        )
      );
    }

    if (this.props.historyBool) {
      // alert("1")
      this.fetchById()
      this.fetchByIdVehicle()
      //console.log(this.props.vehicleGpsId)
      this.gpsRefId = !JSON.parse(localStorage.getItem("sensorWireCut"))
        ? this.props.vehicleGpsId.gpsRefId
        : JSON.parse(localStorage.getItem("sensorWireCut")).gpsRefId;
      this.setState({
        vehicleNumber: !JSON.parse(localStorage.getItem("sensorWireCut"))
          ? this.props.vehicleGpsId.number
          : JSON.parse(localStorage.getItem("sensorWireCut")).number,
      });

      this.getInitialPositions();
      this.props.setHistoryBool(false);
    }

    if (this.state.vehicleCenter == false) {
      // alert("2")
      if (prevProps.location !== this.state.centerCor) {
        if (this.state.progress.length > 0) {
          if (
            typeof this.state.progress[this.state.progress.length - 1].lat ==
            "function"
          ) {
            this.mapRef.panTo(
              new window.google.maps.LatLng(
                this.state.progress[this.state.progress.length - 1] &&
                this.state.progress[this.state.progress.length - 1].lat(),
                this.state.progress[this.state.progress.length - 1] &&
                this.state.progress[this.state.progress.length - 1].lng()
              )
            );
          } else {
            this.mapRef.panTo(
              new window.google.maps.LatLng(
                this.state.progress[this.state.progress.length - 1] &&
                this.state.progress[this.state.progress.length - 1].lat,
                this.state.progress[this.state.progress.length - 1] &&
                this.state.progress[this.state.progress.length - 1].lng
              )
            );
          }
        }
      }
    }

  };

  componentWillMount = () => {
    if (this.props.history === "false") {
      // this.positionUpdate = window.setInterval(this.getPositions30Seconds, 30000);
    }
    // this.positionUpdateStop = window.setInterval(
    //   this.getStopPositions30Seconds,
    //   3000
    // );

    ////console.log(this.state.defaultCenter)
    const queryString = window.location.search;

    ////console.log(queryString);

    const urlParams = new URLSearchParams(queryString);

    const lat1 = 23.73111117910784;
    const lng1 = 87.05557365974347;



    const { centerCor } = this.state; //Gets the object from state
    centerCor.lat = parseFloat(lat1); //do whatever you want with the object
    centerCor.lng = parseFloat(lng1); //do whatever you want with the object

    this.setState({ centerCor });

  };

  vehicleSpeed = (value) => {
    window.clearInterval(this.interval);

    if (value == "replay") {
      this.setState({ vehicleSppeds: 1 });
      this.counter = 0;
      let progress = [];
      this.setState({ progress });
      this.interval = window.setInterval(this.moveObject, 1000);
    } else {
      this.setState({ vehicleSppeds: value });
      this.interval = window.setInterval(this.moveObject, 1000 / value);
    }
  };

  hideNotification = (value) => {
    if (value) {
      document.getElementById("notificationList").style.display = "none";
    } else {
      document.getElementById("notificationList").style.display = "block";
    }
  };

  fetchAddressStop = (lat, lng, id) => {
    //console.log(lat,lng)
    AddressAction.AddressList({
      appKey: JSON.parse(localStorage.getItem("data")).addressAppKey,
      coordinatesDTOList: [
        {
          latitude: lat,
          longitude: lng,
        },
      ],
    }).then((res) => {
      //console.log(res)

      if (res != null) {
        if (res.responseCode == 500 || res.responseCode == 204) {
          // this.setState({address:res.responseDescription})
          document.getElementById(id).innerHTML = res.responseDescription;
        } else {
          let valueAddress = res.data[0].address;

          document.getElementById(id).innerHTML = valueAddress;
          // this.setState({address:valueAddress})
        }
      } else {
        //console.log(JSON.parse(res))
      }
    });
  };

  polygonConvert = (polArray) => {
    console.log(polArray);
    // alert(polArray.length)
    let polyfinalArray = [];
    polArray.forEach((element) => {
      let polyObj = {
        lat: "",
        lng: "",
      };
      polyObj.lat = element.latitude;
      polyObj.lng = element.longitude;
      polyfinalArray.push(polyObj);
    });

    return polyfinalArray;
  };



  render = () => {
    const icon = {
      url: markerIcon,
      scaledSize: new window.google.maps.Size(30, 30),
      anchor: { x: 15, y: 40 },
    };
    const noIcon = {
      url: markerIcon,
      scaledSize: new window.google.maps.Size(0.1, 0.1),
      anchor: { x: 15, y: 40 },
    };
    const iconYellow = {
      url: markerIconYellow,
      scaledSize: new window.google.maps.Size(30, 30),
      anchor: { x: 15, y: 40 },
    };
    const rediconStop = {
      url: stopIcon,
      scaledSize: new window.google.maps.Size(30, 40),
      anchor: { x: 15, y: 15 },
    };

    const redMid = {
      url: redIcon, // url
      scaledSize: new window.google.maps.Size(20, 20), // scaled size
      anchor: new window.google.maps.Point(15, 15), // anchor
    };

    return (
      <div>
        {/* <div
          style={{
            position: "absolute",
            right: "111px",
            top: "-20px",
            color: "green",
          }}
        >
          {" "}
          <Checkbox
            checked={this.state.loadingUnloading}
            onChange={(e) =>
              this.setState({ loadingUnloading: e.target.checked })
            }
          />
          Show Loading Unloading points name
        </div>

        <div
          style={{
            position: "absolute",
            right: "445px",
            top: "-20px",
            color: "green",
          }}
        >
          {" "}
          <Checkbox
            checked={this.state.showSites}
            onChange={(e) => this.setState({ showSites: e.target.checked })}
          />
          Show Sites
        </div>
        <div
          style={{
            position: "absolute",
            right: "410px",
            top: ".5rem",
            color: "green",
          }}
        >
          {" "}
          <Checkbox
            checked={this.state.showrouteCheck}
            onChange={(e) =>
              this.setState({ showrouteCheck: e.target.checked })
            }
          />
          Show Routes
        </div>
        <div
          style={{
            position: "absolute",
            right: "560px",
            top: ".5rem",
            color: "green",
          }}
        >
          {" "}
          <Checkbox
            checked={this.state.vehicleCenter}
            onChange={(e) => this.setState({ vehicleCenter: e.target.checked })}
          />
          Show Vehicle in Center
        </div>

        <div
          style={{
            position: "absolute",
            right: "780px",
            top: ".5rem",
            color: "green",
          }}
        >
          {" "}
          <Checkbox
            checked={this.state.showStops}
            onChange={(e) => this.setState({ showStops: e.target.checked })}
          />
          Show Stops
        </div> */}

        {/* {this.props.history != 'true'  &&  */}
        {/* <div
          style={{
            position: "absolute",
            right: "40px",
            top: "1rem",
            color: "green",
            width: "345px",
          }}
        >
          Vehicle Number :{" "}
          {this.state.vehicleNumber
            ? this.state.vehicleNumber
            : new URL(window.location.href).searchParams.get("Vehicle")}
        </div> */}
         <div
          style={{
            position: "absolute",
            right: "60px",
            top: "4.5rem",
            color: "green",
          }}
        >
          {" "}
          <Checkbox
            checked={this.state.vehicleCenter}
            onChange={(e) => this.setState({ vehicleCenter: e.target.checked })}
          />
          Show Vehicle in Center
        </div>
        <GoogleMap
          style={{ paddingTop: "0rem" }}
          defaultZoom={17}
           defaultCenter={{ lat: 23.73111117910784, lng: 87.05557365974347 }}
          ref={(ref) => {
            this.mapRef = ref;
          }}
           //center={this.state.centerCor}
        >


         


          {this.state.pathLIneTrip.length > 1 ? (
            <>
              <Polyline
                path={this.state.pathLIneTrip}
                options={{
                  strokeColor: "blue",
                 
                  icons: [
                    {
                      icon: {
                        path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                        strokeColor: "green",
                        // fillColor:"yellow"

                      },
                      offset: '100%',
                      repeat: '100px',
                    },
                  ],
                }}
                // onClick={()=>this.handleToggleOpen(this.state.pathLIneTrip)}
              
              />
              
                {/* {this.path && this.path.length> 0 && this.path.map((val)=>{
                console.log(val,"vaghjl")
                return(
                  <>
                 
                    <InfoWindow
                      position={this.state.pathLIneTrip[this.state.pathLIneTrip.length - 1]}
                      options={{
                        pixelOffset: new window.google.maps.Size(0, -5),
                        background: "blue",
                      }}
                      draggable={true}
                    >
                      <div
                        style={{ display: "flex", flexDirection: "column", rowGap: 3, padding: 3, background: "red", fontWeight: 500 }}
                      >
                        <p className="">{`${this.state.userInfo.userName} ${this.state.userInfo.userName ? `(${this.state.userInfo.userName})` : ""
                          }`}</p>
                        <p className="">
                          {`Time ${moment(this.state.userInfo.endPoint.serverTime).format("HH:mm")}`}
                        </p>
                        <p className="">
                          {`Distance:  ${this.state.userInfo.distance.toFixed(2)} km`}
                        </p>
                      </div>
                    </InfoWindow>

                 
              
              </>
              )
            })} */}


              <Marker
                icon={{
                  url: this.state.userInfo.imgUrl,
                  origin: new window.google.maps.Point(0, 0),
                  anchor: new window.google.maps.Point(15, 15),
                  scaledSize: new window.google.maps.Size(30, 30),
                  shape: { coords: [17, 17, 18], type: "circle" },
                  optimized: false,
                  title: "spot",
                  // shape: { coords: [50, 50, 18], type: "circle" },
                }}
                position={this.state.pathLIneTrip[this.state.pathLIneTrip.length - 1]}

              />

            


              <InfoWindow
                position={this.state.pathLIneTrip[this.state.pathLIneTrip.length - 1]}
                options={{
                  pixelOffset: new window.google.maps.Size(0, -5),
                  background: "blue",
                }}
                draggable={true}
              >
                <div
                  style={{ display: "flex", flexDirection: "column", rowGap: 3, padding: 3, background: "red", fontWeight: 500 }}
                >
                  <p className="">{`${this.state.userInfo.userName} ${this.state.userInfo.userName ? `(${this.state.userInfo.userName})` : ""
                    }`}</p>
                  <p className="">
                    {`Time ${moment(this.state.userInfo.endPoint.serverTime).format("HH:mm")}`}
                  </p>
                  <p className="">
                    {`Distance:  ${this.state.userInfo.distance.toFixed(2)} km`}
                  </p>
                </div>
              </InfoWindow>


              <InfoWindow
                position={this.state.pathLIneTrip[0]}
                options={{
                  pixelOffset: new window.google.maps.Size(0, -5),
                  background: "blue",
                }}
                draggable={true}
              >
                <div

                  style={{ display: "flex", flexDirection: "column", rowGap: 3, padding: 3, background: "green", fontWeight: 500 }}
                >
                  <p className="">
                    {`Start Time ${moment(this.state.userInfo.startPoint.serverTime).format("HH:mm")}`}
                  </p>
                </div>
              </InfoWindow>
            </>
          ) : (
            ""
          )}


        </GoogleMap>




      </div>
    );
  };
}

const MapComponent = withScriptjs(withGoogleMap(Map));

export default (props) => (
  <MapComponent
    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${config.apiKey}&v=3.exp&libraries=geometry,drawing,places`}
    loadingElement={<div style={{ height: `100%` }} />}
    containerElement={<div style={{ height: `93vh`, width: "100%" }} />}
    mapElement={<div style={{ height: `100%` }} />}
    {...props}
  />
);
